module.exports = __webpack_public_path__ + "716b143d91cd786597708be3df07601f.svg";